import { Button, Grid, IconButton, Paper, Typography } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import moment from "moment";
import React from "react";
import { RegistrationType } from "../../Base/AdoptionConstants";
import useAdminContext from "../AdminContextProvider";
import AdminNoMatchDialog from "../AdminNoMatchDialog";

export default function FindMatch({ registration, forwardedRef, ...props }) {
  const [open, setOpen] = React.useState(false);
  const adminContext = useAdminContext();

  function handleMarkAsSearched() {
    setOpen(true);
  }

  return (
    <Paper {...props} ref={forwardedRef} elevation={4} style={{ padding: "10px" }}>
      {registration && (
        <div>
          <Grid
            style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}
          >
            <Typography variant="h3" className="h3-header">
              Find Match
            </Typography>
            <IconButton
              color="default"
              aria-label="close"
              onClick={() => adminContext.setSelectedRegistration(null)}
              style={{ padding: 0 }}
            >
              <ClearIcon />
            </IconButton>
          </Grid>
          <Grid container display="flex" flexDirection="row" justify="space-between">
            <Grid item xs={12} sm={8} style={{ display: "flex" }}>
              <Grid container alignItems="flex-end" spacing={2}>
                <Grid item sm={12}>
                  <label style={{ fontWeight: 500, fontSize: 14 }}>Registrant:</label>
                  <span style={{ paddingLeft: "5px" }}>
                    {registration.registrant.contactInformation.firstName}{" "}
                    {registration.registrant.contactInformation.lastName}
                  </span>
                </Grid>
                <Grid item sm={12}>
                  <label style={{ fontWeight: 500, fontSize: 14 }}>Date of Birth: </label>
                  {registration.birthDateRangeEnd && registration.birthDateRangeStart && (
                    <span style={{ paddingLeft: "5px" }}>
                      {moment(registration.birthDateRangeStart).format("LL")}
                      {" - "}
                      {moment(registration.birthDateRangeEnd).format("LL")}
                    </span>
                  )}
                  {registration.birthDate && (
                    <span style={{ paddingLeft: "5px" }}>{moment(registration.birthDate).format("LL")}</span>
                  )}
                </Grid>
                <Grid item sm={12}>
                  <label style={{ fontWeight: 500, fontSize: 14 }}>Relationship: </label>
                  <span style={{ paddingLeft: "5px" }}>{RegistrationType[registration.registrationType].label}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={3}>
              <Grid container alignItems="center" justify="center" spacing={2}>
                <Grid item xs={12}>
                  <Button variant="contained" color="default" size="small" onClick={handleMarkAsSearched}>
                    Mark as Searched/No Match
                  </Button>
                </Grid>
                <Grid item sm={12}>
                  <Button
                    variant="contained"
                    color="default"
                    size="small"
                    style={{ marginTop: "5px" }}
                    onClick={() => adminContext.openDetailsForUserFriendlyRegistrationId(registration.userFriendlyId)}
                  >
                    View Details
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <AdminNoMatchDialog
            open={Boolean(open)}
            registrationId={registration.registrationId}
            onClose={() => {
              setOpen(false);
            }}
          />
        </div>
      )}
    </Paper>
  );
}
